export default "__VITE_ASSET__DF6uAFty__"